export default __webpack_public_path__ + "static/color-picker-role-dont-8440daaf5e158f76c758d5a4ac166adf.png";